import type { AgentVersion } from "src/clients/agent-management";
import { Accordion } from "src/design-system/Accordion";
import type { JsonSchema } from "src/jsonSchema/types";
import { JSONSchemaRenderer } from "src/jsonSchema/viewer/JSONSchemaRenderer";

type Props = {
  schema: AgentVersion["configuration"]["output_schema"] | undefined;
  isLoading?: boolean;
  // Flow path the agent response is written to. When set, every field is
  // labelled with the expression downstream nodes use to read it.
  basePath?: string;
};

export const AgentOutputSchema: React.FC<Props> = ({
  schema,
  isLoading = false,
  basePath,
}) => (
  <Accordion dataLoc="agent-output-schema">
    <Accordion.Item
      isLoading={isLoading}
      label="Output schema"
      value="output-schema"
    >
      {schema && Object.keys(schema).length > 0 ? (
        <JSONSchemaRenderer
          basePath={basePath}
          displayOptions={{
            showPrimitiveTypeLabels: true,
            showDataPaths: basePath !== undefined,
            showPrimitiveDataPath: basePath !== undefined,
          }}
          schema={schema as JsonSchema}
        />
      ) : (
        <p>No output schema defined for this Agent version.</p>
      )}
    </Accordion.Item>
  </Accordion>
);
